import { RadioKnobIcon, RadioRoundIcon, StackIcons } from '@dhl-ui/icons'
import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

// see MuiFormGroup, MuiFormControl & FormLabel for more styling
export const createMuiRadio = ({ misc }: Pick<Tokens, 'misc'>) =>
  ({
    MuiRadio: {
      defaultProps: {
        icon: <RadioRoundIcon />,
        checkedIcon: (
          <StackIcons variant="full">
            <RadioKnobIcon />
            <RadioRoundIcon />
          </StackIcons>
        ),
        disableRipple: true,
        color: 'dark',
      },
      styleOverrides: {
        root: {
          margin: 0,
          padding: 0,
          '&.MuiRadio-root + .MuiFormControlLabel-label': {
            marginLeft: spacing(1.5),
          },
          '&.MuiRadio-root + div .MuiFormControlLabel-label': {
            marginLeft: spacing(1.5),
          },
          ...misc.createFocusVisibleState({
            outline: misc.borderStyle('dark.states.focus', 3),
            boxShadow: 'none',
          }),
          ...misc.createHoverOrActiveState({
            backgroundColor: 'none',
            outline: misc.borderStyle('dark.states.hover', 3),
          }),
        },
      },
    },
  }) satisfies ComponentCreation
